const initialstate ={
    password:[],
}
 
const ResetPasswordReducers = (state = initialstate, action: any) => {
    switch (action.type) {
        case 'RESET_PASSWORD_SUCCESS':
          return { ...state, password: action.payload };

          default:
            return state;
    }
};
export default ResetPasswordReducers;
